import type { ReactNode } from 'react';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Box from '@mui/material/Box';

/**
 * FormField
 * Classification: mui-wrapper
 *
 * Standardizes the label + control + helper/error layout used across product
 * forms, so any control (TextField, Select, Search, Slider...) gets consistent
 * spacing, required markers and error messaging.
 */
export interface FormFieldProps {
  label: string;
  /** The input control. */
  children: ReactNode;
  helperText?: string;
  error?: boolean;
  required?: boolean;
  /** Associates the label with the control. */
  htmlFor?: string;
  fullWidth?: boolean;
}

export function FormField({
  label,
  children,
  helperText,
  error = false,
  required = false,
  htmlFor,
  fullWidth = true,
}: FormFieldProps) {
  return (
    <FormControl error={error} required={required} fullWidth={fullWidth} sx={{ gap: 0.5 }}>
      <FormLabel htmlFor={htmlFor} sx={{ typography: 'caption', fontWeight: 600 }}>
        {label}
      </FormLabel>
      <Box>{children}</Box>
      {helperText ? <FormHelperText sx={{ mx: 0 }}>{helperText}</FormHelperText> : null}
    </FormControl>
  );
}
